// src/components/HomePage/ServiceStats.jsx
import React, { memo, useState, useEffect } from 'react';
import { getNextStatValue, getSmoothNoise } from '../../utils/smartNoise';

const ServiceStats = memo(() => {
  const [liveStats, setLiveStats] = useState({
    totalServers: '43,123',
    vulnerabilities: '8,741',
    accountsChecked: '153K',
    activeUsers: '3,132',
    stability: '99.4%'
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveStats(prev => ({
        totalServers: getNextStatValue(prev.totalServers, { maxChange: 0.0001 }),
        vulnerabilities: getNextStatValue(prev.vulnerabilities, { maxChange: 0.00005 }),
        accountsChecked: getNextStatValue(prev.accountsChecked, { maxChange: 0.0002 }),
        activeUsers: getSmoothNoise(prev.activeUsers, 0.03),
        stability: '99.4%'
      }));
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const stats = [
    {
      title: 'Протестировано серверов',
      value: liveStats.totalServers,
      sub: 'Глобальный охват сканирования',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
          <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
        </svg>
      )
    },
    {
      title: 'Найдено уязвимостей',
      value: liveStats.vulnerabilities,
      sub: 'Точек отказа инфраструктуры',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      )
    },
    {
      title: 'Проверено аккаунтов',
      value: liveStats.accountsChecked,
      sub: 'Индекс валидности 56.8%',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      )
    },
    {
      title: 'Активных операторов',
      value: liveStats.activeUsers,
      sub: 'Операторов в системе',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="8" r="5" />
          <path d="M20 21a8 8 0 1 0-16 0" />
        </svg>
      )
    },
    {
      title: 'Индекс стабильности',
      value: liveStats.stability,
      sub: 'Время отклика кластера',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
      )
    }
  ];

  return (
    <section className="mb-10 sm:mb-[65px]" id="statsSection">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2.5 sm:gap-4">
        {stats.map((stat, i) => (
          <div
            key={i}
            className={`rounded-[16px] sm:rounded-[20px] p-3.5 sm:p-[18px_20px_16px_20px] flex flex-col justify-between border border-[#1e222d] hover:border-[#2d3342] bg-[#111319] hover:bg-[#151821] hover:-translate-y-[2px] transition-all duration-250 shadow-[0_4px_16px_rgba(0,0,0,0.3)] hover:shadow-[0_12px_28px_rgba(0,0,0,0.5)] group relative overflow-hidden select-none ${
              i === 4 ? 'col-span-2 lg:col-span-1' : ''
            }`}
          >
            {/* Фоновая SVG иконка справа внизу (дизайн ServersParser) */}
            <div className="absolute -right-2 -bottom-2 w-[72px] h-[72px] sm:w-[92px] sm:h-[92px] text-white opacity-[0.035] group-hover:opacity-[0.07] group-hover:scale-105 group-hover:rotate-0 -rotate-3 transition-all duration-300 pointer-events-none z-0 [&_svg]:w-full [&_svg]:h-full">
              {stat.icon}
            </div>

            {/* Внутренний контент карточки */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <span className="text-[0.68rem] sm:text-[0.76rem] text-white/65 font-semibold leading-snug uppercase tracking-[0.05em] h-auto sm:h-[2.4em] mb-1 sm:mb-0 flex items-start">
                {stat.title}
              </span>
              <div
                className="text-[1.85rem] sm:text-[2.85rem] font-bold tracking-[0.02em] leading-[0.95] text-white my-1 group-hover:text-white transition-colors"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                {stat.value}
              </div>
              <div className="text-[0.66rem] sm:text-[0.72rem] text-white/55 font-medium leading-tight mt-0.5 sm:mt-0">
                {stat.sub}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
});

export default ServiceStats;